module.exports = __webpack_public_path__ + "assets/align-bottom-blue.8cd21d1e.svg";